<template>
    <div class="flex justify-center items-center pt-12">
        <v-form name="formSetting"
                class="shadow-box border border-gray-100 bg-white rounded-md shadow-md form-body"
                style="border:1px solid #e0e0e0; padding:10px; width:100%; max-width:900px; margin:0 auto;">
            <Tabs value="0"
                  scrollable>
                <TabList class="mb-4">
                    <Tab value="0">{{ __('Basic data') }}</Tab>
                </TabList>
                <TabPanels>
                    <TabPanel value="0">
                        <div class="grid">
                            <FormCalendar fieldName="test_current_date"
                                          label="Test current date"
                                          size="4"
                                          :isFormDisabled="false"
                                          v-model:field="config.test_current_date"
                                          class="w-full h-12 text-base" />

                            <FormInputNumber fieldName="info_timeout"
                                             label="Czas wyświetlania informacji (sekundy, 0-120)"
                                             size="4"
                                             :min="0"
                                             :max="120"
                                             :minFractionDigits="0"
                                             :maxFractionDigits="0"
                                             v-model:field="config.info_timeout"
                                             class="w-full h-12 text-base" />

                            <FormInputNumber fieldName="error_timeout"
                                             label="Czas wyświetlania błędu (sekundy, 0-120)"
                                             size="4"
                                             :min="0"
                                             :max="120"
                                             :minFractionDigits="0"
                                             :maxFractionDigits="0"
                                             v-model:field="config.error_timeout"
                                             class="w-full h-12 text-base" />
                        </div>
                        <div class="grid">
                            <FormInputText fieldName="company_name"
                                           label="Company name"
                                           size="12"
                                           v-model:field="config.company_name" />
                        </div>
                        <div class="grid">
                            <FormInputText fieldName="city"
                                           label="City"
                                           size="4"
                                           v-model:field="config.city" />

                            <FormInputText fieldName="postal_code"
                                           label="Postal code"
                                           size="2"
                                           v-model:field="config.postal_code" />

                            <FormInputText fieldName="address"
                                           label="Address"
                                           size="6"
                                           v-model:field="config.address" />
                        </div>
                        <div class="grid">
                            <FormInputText fieldName="nip"
                                           label="NIP"
                                           size="4"
                                           v-model:field="config.nip" />
                            <FormInputText fieldName="phone"
                                           label="Phone"
                                           size="4"
                                           v-model:field="config.phone" />
                            <FormInputText fieldName="fax"
                                           label="Fax"
                                           size="4"
                                           v-model:field="config.fax" />
                        </div>
                        <div class="grid">
                            <FormInputText fieldName="mobile"
                                           label="Mobile"
                                           size="4"
                                           v-model:field="config.mobile" />
                            <FormInputText fieldName="website"
                                           label="Website"
                                           size="4"
                                           v-model:field="config.website" />
                            <FormInputText fieldName="email"
                                           label="Email"
                                           size="4"
                                           v-model:field="config.email" />
                        </div>
                        <div class="grid">
                            <FormInputText fieldName="bank_name"
                                           label="Bank name"
                                           size="6"
                                           v-model:field="config.bank_name" />
                            <FormInputText fieldName="bank_account"
                                           label="Bank account"
                                           size="6"
                                           v-model:field="config.bank_account" />
                        </div>

                    </TabPanel>
                </TabPanels>
            </Tabs>
            <div style="margin-top:20px;text-align:right;margin-left:auto;margin-right:auto;">
                <hr style="margin-bottom:20px">
                <div class="flex justify-content-end">
                    <Button @click="saveData"
                            :disabled="config.processing"
                            style="margin:0 5px"
                            severity="success"
                            class="bg-secondary-500 hover:bg-gray-200 text-white hover:text-gray-600 font-medium py-1 px-2.5 rounded-md border border-gray-200 hover:border-gray-300 transition-colors duration-150 flex items-center gap-2">
                        {{ __('Save') }}
                    </Button>
                    <Button @click="cancelData"
                            :disabled="config.processing"
                            style="margin:0 5px"
                            severity="secondary"
                            class="bg-white hover:bg-gray-200 text-gray-600 font-medium py-1 px-2.5 rounded-md border border-gray-200 hover:border-gray-300 transition-colors duration-150 flex items-center gap-2">
                        {{ __('Cancel') }}
                    </Button>
                </div>
            </div>
        </v-form>
    </div>
</template>

<script setup>
import { ref } from 'vue'

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormCalendar from '@crud/FormCalendar.vue'
import FormInputNumber from '@crud/FormInputNumber.vue'
import FormInputText from '@crud/FormInputText.vue'
import Button from 'primevue/button';
import { useForm, router } from '@inertiajs/vue3';
import { __, convertDate } from '@pages/Helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    data: Object,
})

const config = ref(props.data)

// -----------------------------------------------------

const saveData = () => {
    useForm({
        ...config.value,
        'test_current_date': convertDate(config.value.test_current_date),
        'info_timeout': config.value.info_timeout,
        'error_timeout': config.value.error_timeout,
        'company_name': config.value.company_name,
        'city': config.value.city,
        'address': config.value.address,
        'postal_code': config.value.postal_code,
        'nip': config.value.nip,
        'phone': config.value.phone,
        'fax': config.value.fax,
        'mobile': config.value.mobile,
        'email': config.value.email,
        'website': config.value.website,
    }).post(route('set-setting'), {
        preserveState: true,
        preserveScroll: true,
        onError: (errors) => {
            console.error(errors)
        },
        onSuccess: () => {
        },
        onFinish: () => {
        }
    })
}

// -----------------------------------------------------

const cancelData = () => {
    router.get(route('system-start'));
}

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
